// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { execute }  from 'fg-frontend/src/partialUpdate/partialUpdate';

export default class Execute extends WebComponent {
  didMount() {
    const {
            url,
            target,
          } = this.props;
    execute({
      url:    url,
      target: target,
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Execute.js